<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="company">
                <div class="row">
                  <div class="col-md-12">
                    <company-beneficialowner-array
                      formArrayName="beneficialOwner"
                      [derrors]="derrors"
                    >
                    </company-beneficialowner-array>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
